<template>
  <div class="gap-sm">
    <q-input v-model="model" outlined placeholder="Ex. 10.29070/13/57895" dense />
    <q-btn :loading="loading" @click="$emit('click')">Fetch</q-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    loading: Boolean
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  }
}
</script>
